import styled from 'styled-components'
import {blackColor, grey100, grey35, mainTextColor, secondTextColor} from '../../../../@theme/vars'

export const PublicationFormOverviewBlockImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-top: 24px;
  margin-bottom: 0px;
`

export const PublicationFormOverviewBlockImageHeaderWrapper = styled.div`
  color: ${blackColor};
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  border: 1px solid ${grey35};
  background: #f1f6ff;
  width: 100%;
  border-radius: 6px 6px 0px 0px;
  padding: 12px 20px;
`

export const PublicationFormOverviewBlockImagePhotoInfoWrapper = styled.div`
  color: ${grey100};
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  margin-top: 8px;
`

export const PublicationFormOverviewBlockImageInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
  padding: 20px 24px;
  border-left: 1px solid ${grey35};
  border-bottom: 1px solid ${grey35};
  border-right: 1px solid ${grey35};
  border-radius: 0px 0px 6px 6px;

  @media screen and (max-width: 750px) {
    flex-direction: column;
  }
`

export const OverviewBlockImageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 750px) {
    margin-bottom: 24px;
  }

  & #overviewBlockPhoto {
    &:hover {
      cursor: pointer;
      opacity: 1;
    }
    & figure {
      width: 240px;

      @media screen and (max-width: 750px) {
        width: 100%;
      }

      & figcaption {
        & .image-description {
          margin-top: 6px;
          line-height: 16px;
          color: ${mainTextColor};
        }
        & .image-author {
          font-size: 12px;
          margin-top: 6px;
          line-height: 14px;
          color: ${secondTextColor};
        }
      }

      & .change-item,
      & .delete-item {
        position: absolute;
        opacity: 0.8;
        border-radius: 80%;
        height: 26px;
        width: 26px;
        margin: 16px 6px 6px 0px;

        &:hover {
          cursor: pointer;
          opacity: 1;
        }
      }

      & .delete-item {
        display: none;
      }

      /* & .delete-item {
        margin-left: 168px;

        @media screen and (max-width: 750px) {
          margin-left: calc(100% - 142px);
        }
      } */
      & .change-item {
        margin-left: 200px;

        @media screen and (max-width: 750px) {
          margin-left: calc(100% - 110px);
        }
      }
    }
  }
`
